import { render, staticRenderFns } from "./explainer-customer-response.vue?vue&type=template&id=225c6bb8&scoped=true&"
import script from "./explainer-customer-response.vue?vue&type=script&lang=js&"
export * from "./explainer-customer-response.vue?vue&type=script&lang=js&"
import style0 from "./explainer-customer-response.vue?vue&type=style&index=0&id=225c6bb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225c6bb8",
  null
  
)

export default component.exports